import { RadarLoader } from "design_system_radar/loaders/RadarLoader";

export default function FullScreenLoader() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <RadarLoader />
    </div>
  );
}
